import { createReducer } from 'typesafe-actions'
import { CampaignAction, CampaignState } from './types'
import { fetchCampaignByIdHandle, fetchManyByCampaignIdsHandle } from './handles'

const initialState: CampaignState = {
  campaignsByAttend: [],
  isLoadingFetchManyByCampaignIds: false,
  isErrorFetchManyByCampaignIds: false,
  isSuccessFetchManyByCampaignIds: false,
  isSuccessFetchCampaignById: false,
  isErrorFetchCampaignById: false,
  isLoadingFetchCampaignById: false,
  campaign: null
}

export const campaignReducer = createReducer<CampaignState, CampaignAction>(initialState)
  .handleAction(fetchManyByCampaignIdsHandle.asyncAction.request, fetchManyByCampaignIdsHandle.request)
  .handleAction(fetchManyByCampaignIdsHandle.asyncAction.success, fetchManyByCampaignIdsHandle.success)
  .handleAction(fetchManyByCampaignIdsHandle.asyncAction.failure, fetchManyByCampaignIdsHandle.failure)
  .handleAction(fetchCampaignByIdHandle.asyncAction.failure, fetchCampaignByIdHandle.failure)
  .handleAction(fetchCampaignByIdHandle.asyncAction.request, fetchCampaignByIdHandle.request)
  .handleAction(fetchCampaignByIdHandle.asyncAction.success, fetchCampaignByIdHandle.success)
